import { setToken } from "@/utils/auth";
const user = {
  state: {
    key: [],
    rocker: false,
    joystick: {
      x: 0,
      y: 0,
    },
    token: "",
    language: "zh",
  },

  mutations: {
    SET_DATA: (state, data) => {
      state.key = data.key;
      state.rocker = data.gyroBtn;
      state.joystick = data.direction;
      // state.language = data.language;
    },
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_LANGUAGE: (state, language) => {
      state.language = language;
    },
  },

  actions: {
    // 全局数据保存
    delData({ commit }, data) {
      return new Promise((resolve) => {
        commit("SET_DATA", data);
        // console.log(data, 222);
        resolve();
      });
    },
    // 语言
    delLanguage({ commit }, language) {
      return new Promise((resolve) => {
        commit("SET_LANGUAGE", language);
        // console.log(data, 222);
        resolve();
      });
    },
    // 登录
    enterLogin({ commit }, token) {
      setToken(token);
      commit("SET_TOKEN", token);
    },
  },
};

export default user;
